<template>
  <section class="section pt-5">
    <service-datatable />
  </section>
</template>

<script>
import ServiceDatatable from "./service_datatable/Index.vue";

export default {
  name: "ServicesIndex",
  components: { ServiceDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
